export class Flash {
  open (flash) {
    var event = new CustomEvent('vueFlash', {
      detail: {
        message: flash.message,
        level: flash.type.substring(3)
      }
    });

    window.dispatchEvent(event);
  };
  flush () {
    var event = new Event('vueFlush');

    window.dispatchEvent(event);
  };
}
